<template>
  <div id="app">
    <ChatWidget @hide="showChat = false" />
  </div>
</template>

<script>
import ChatWidget from './components/ChatWidget.vue';

export default {
  data() {
    return {
      showChat: true,
    };
  },
  components: {
    ChatWidget,
  },
  mounted() {
    console.log("Vue App Mounted");  // 调试日志
  },
};
</script>

<style>
/* 根组件不需要样式 */
</style>